/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Publish_TitleInputs */

const en_mk_publish_title = /** @type {(inputs: Mk_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See it working. Publish when ready.`)
};

const id_mk_publish_title = /** @type {(inputs: Mk_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat hasilnya. Terbitkan saat siap.`)
};

/**
* | output |
* | --- |
* | "See it working. Publish when ready." |
*
* @param {Mk_Publish_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_publish_title = /** @type {((inputs?: Mk_Publish_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Publish_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_publish_title(inputs)
	return en_mk_publish_title(inputs)
});